<template>
  <vuestic-widget header-text="Cheques">
    <div class="filtros">
      <div class="form-group">
        <div class="input-group mr-1">
          <input-comp label="Cuenta" @change="addCuenta" v-model="filtros.cuenta"/>
        </div>
        <div class="input-group mr-1">
          <label for="filtro-fecha">Fecha Vencimiento</label>
          <input @change="addFecha" type="date" id="filtro-fecha" v-model="filtros.fecha_vencimiento">
          <i class="bar"></i>
        </div>
        <div class="input-group mr-1">
          <input-comp @change="addMonto" placeholder="$ 0" label="Monto" v-model="filtros.monto"/>
        </div>
        <div class="input-group mr-1">
          <label for="estado_cheque">Estado</label>
          <select @change="addEstado" v-model="filtros.estado" name="estado" id="estado_cheque">
            <option value="">Seleccione...</option>
            <option value="pendiente">Pendiente</option>
            <option value="protestado">Protestado</option>
            <option value="depositado">Depositado</option>
            <option value="redepositado">Redepositado</option>
          </select>
          <i class="bar"></i>
        </div>
      </div>
    </div>

    <table class="table table-bordered">
      <thead class="thead-light">
      <tr>
        <th>Fecha</th>
        <th>Caja</th>
        <th>Venta</th>
        <th>Banco</th>
        <th>Cuenta</th>
        <th>Cheque</th>
        <th>Vencimiento</th>
        <th>Días</th>
        <th>Monto</th>
        <th>Estado</th>
        <th>Opciones</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="cheque in cheques">
        <td>{{cheque.dte.date|fecha}}</td>
        <td>{{cheque.caja.folio}}</td>
        <td>{{cheque.dte | venta}}</td>
        <td>{{cheque.banco.toUpperCase()}}</td>
        <td>{{cheque.cuenta}}</td>
        <td>{{cheque.numero}}</td>
        <td>{{cheque.vencimiento|fecha}}</td>
        <td></td>
        <td>{{cheque.monto|currency}}</td>
        <td>{{cheque.estado.toUpperCase()}}</td>
        <td>
          <i class="fa fa-list-alt" title="Ver Movimientos" @click="openMovimientosModal(cheque)"></i>
          &nbsp;
          <i class="fa fa-plus-square" title="Agregar Movimiento" @click="openAgregarModal(cheque)"></i>
        </td>
      </tr>
      </tbody>
    </table>
    <paginacion :current-page="currentPage" @next="nextPage" @back="backPage"/>

    <vuestic-modal ref="modalMovimientos" :large="true">
      <h5 slot="title">Movimientos</h5>
      <table class="table table-bordered">
        <thead>
        <tr>
          <th>Fecha</th>
          <th>Estado</th>
          <th>Tipo Cancelación</th>
          <th>Detalles</th>
          <th>Comentario</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="movimiento in movimientos">
          <td>{{movimiento.fecha|fecha}}</td>
          <td>{{movimiento.estado}}</td>
          <td>{{movimiento.tipo_cancelacion}}</td>
          <td v-html="detailList(movimiento.detalles)"></td>
          <td>{{movimiento.comentario}}</td>
        </tr>
        </tbody>
      </table>
    </vuestic-modal>
    <vuestic-modal ref="modalAgregar" :large="true">
      <h5 slot="title">Agregar Movimiento</h5>
      <form @submit.prevent="agregarMovimiento">
        <div class="form-group">
          <div class="input-group">
            <label for="estado">Estado</label>
            <select id="estado" v-model="model.estado">
              <option value="pendiente">Pendiente</option>
              <option value="depositado">Depositado</option>
              <option value="protestado">Protestado</option>
              <option value="redepositado">Redepositado</option>
            </select>
            <i class="bar"></i>
          </div>
        </div>
        <div class="form-group" v-if="['depositado', 'redepositado'].includes(model.estado)">
          <div class="input-group">
            <label for="tipoCancelacion">Tipo Cancelación</label>
            <select id="tipoCancelacion" v-model="model.tipoCancelacion">
              <option value="deposito">Deposito</option>
              <option value="efectivo">Efectivo</option>
            </select>
            <i class="bar"></i>
          </div>
        </div>
        <div v-if="model.tipoCancelacion === 'deposito'">
          <div class="form-group">
            <div class="input-group">
              <label for="fecha">Fecha</label>
              <input type="date" id="fecha" v-model="model.detalles[0].fecha"/>
              <i class="bar"></i>
            </div>

          </div>
          <div class="form-group">
            <div class="input-group">
              <label for="banco">Banco</label>
              <input type="text" id="banco" v-model="model.detalles[0].banco"/>
              <i class="bar"></i>
            </div>
          </div>

          <div class="form-group">
            <div class="input-group">
              <label for="numero">Número deposito</label>
              <input id="numero" v-model="model.detalles[0].numero">
              <i class="bar"></i>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="input-group">
            <label for="comentario">Comentario</label>
            <input id="comentario" v-model="model.comentario">
            <i class="bar"></i>
          </div>
        </div>

        <button class="btn btn-warning btn-micro" type="submit">Guardar</button>
      </form>
    </vuestic-modal>
  </vuestic-widget>

</template>
<script>
  import VuesticWidget from "../../../vuestic-theme/vuestic-components/vuestic-widget/VuesticWidget";
  import axios from 'axios'
  import moment from 'moment'
  import {CHEQUES, MOVIMIENTOS} from "../routes";
  import VuesticModal from "../../../vuestic-theme/vuestic-components/vuestic-modal/VuesticModal";
  import InputComp from "../../Componentes_Globales/Input/inputComp";
  import bancos from "../../Caja/js/bancos";
  import makeQuery from "../../../api/helper";
  import Paginacion from "../../Componentes_Globales/paginacion/paginacion";

  export default {
    name: 'cheques',
    components: {Paginacion, InputComp, VuesticModal, VuesticWidget},
    created() {
      this.loadData()
    },
    methods: {
      agregarMovimiento() {
        this.$axios.put(MOVIMIENTOS + this.model.id, this.model)
          .then(({data}) => {
            this.loadData()
            this.cerrarModalAgregar()
          }).catch(e => alert(e.message))
      },
      async loadData() {
        const query = makeQuery({
          filtros: [this.cuenta, this.fecha_vencimiento, this.monto, this.estado],
          limite: this.limite,
          offset: this.offset
        })
        const {data} = await this.$axios.get(CHEQUES + query)
        this.cheques = data.items
      },
      addCuenta() {
        this.cuenta = this.filtros.cuenta ? {field: 'cuenta', value: this.filtros.cuenta, operator: '='} : {}
        this.loadData()
      },
      addFecha() {
        this.fecha_vencimiento = this.filtros.fecha_vencimiento ? {
          field: 'vencimiento',
          value: moment(this.filtros.fecha_vencimiento).format() === 'Invalid date' ? '' : moment(this.filtros.fecha_vencimiento).format('DD-MM-YYYY'),
          operator: '='
        } : {}
        this.loadData()
      },
      addMonto() {
        this.monto = this.filtros.monto ? {field: 'monto', value: this.filtros.monto, operator: '='} : {}
        this.loadData()
      },
      addEstado() {
        this.estado = this.filtros.estado ? {field: 'estado', value: this.filtros.estado, operator: '='} : {}
        this.loadData()
      },
      nextPage() {
        this.currentPage++
        this.offset = this.limite * (this.currentPage - 1)
        this.loadData()
      },
      backPage() {
        this.currentPage--
        this.offset = this.limite * (this.currentPage - 1)
        this.loadData()
      },
      openMovimientosModal(cheque) {
        this.movimientos = [...cheque.movimientos]
        console.log(this.movimientos)
        this.$refs.modalMovimientos.open()
      },
      openAgregarModal({id, estado}) {
        this.model.id = id
        this.model.estado = estado
        console.log(this.model)
        this.$refs.modalAgregar.open()
      },
      cerrarModalAgregar() {
        this.model = Object.assign({}, {
          tipoCancelacion: '',
          estado: 'pendiente',
          detalles: [
            {
              fecha: '',
              banco: '',
              numero: ''

            }
          ]
        })
        this.$refs.modalAgregar.close()
      },
      detailList: function (value) {
        let html = "<ul>"
        value.forEach(m => html += Object.keys(m).map(k => `<li>${k}: ${m[k]}</li>`).join(""))
        return html += "</ul>"
      }
    },
    data() {
      return {
        bancos,
        cuenta: {},
        fecha_vencimiento: {},
        estado: {},
        monto: {},
        currentPage: 1,
        limite: 30,
        offset: 0,
        filtros: {
          banco: '',
          fecha: '',
          monto: '',
          fecha_vencimiento: '',
          estado: '',
          cuenta: '',
          cheque: ''
        },
        fecha: null,
        cheques: [],
        movimientos: [],
        model: {
          tipoCancelacion: '',
          estado: 'pendiente',
          detalles: [
            {
              fecha: '',
              banco: '',
              numero: ''

            }
          ],
        }
      }
    },
    filters: {
      fecha: function (value) {
        return moment(value).format('DD/MM/YYYY')
      },
      venta: function (value) {
        console.log(value)
        let prefix
        switch (value.codigo) {
          case 33:
            prefix = "FE-"
            break;
          case 39:
            prefix = "BE-"
            break
          case 11:
            prefix = 'PC-'
        }
        return prefix + value.folio
      }
    }
  }
  /**
   * fecha
   * caja
   * venta
   * banco
   * numero cuenta
   * numero cheque
   * fecha vencimiento
   * dias
   * monto
   * estado
   * botones
   */
</script>

